import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

/** API-клиент с редиректом на /billing при 402 (доступ к платформе приостановлен). */
export function createPlatformApi() {
    const token = localStorage.getItem('token');
    const api = axios.create({
        baseURL: getApiBaseUrl(),
        headers: token ? { Authorization: `Bearer ${token}` } : {}
    });

    api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 402) {
                const path = window.location.pathname || '';
                if (!path.startsWith('/billing')) {
                    window.location.href = '/billing';
                }
            }
            return Promise.reject(error);
        }
    );

    return api;
}
